import "./ProbabilityScoreGrid.css"; // Add this import for CSS
import useProbabilityFlagBaseType from "../hooks/useProbabilityFlagBaseType";

// Add Operating Temperature to column titles
const colTitles = ['Operating Temperature', 'Coating Status', 'Cladding/Insulation Condition', 'Insulation Type', 'Heat Tracing', 'External Environment', 'Score']
const lastColData = [0, 1, 3, 5]

// Sample operating temperature text data
const operatingTempData = [
    <>Constantly <br /> &lt;-5°C or &gt;175°C <br /> &lt;25°F or &gt;350°F <br />   <b>REMOVE FROM CUI PROGRAM</b></>,
    <>150°C - 175°C <br />300°F - 350°F</>,
    <>-5°C - 49°C <br />  26°F - 119°F  <br /> OR <br /> 111°C - 149°C <br /> 226°F - 299°F</>,
    <>50°C - 110°C <br /> 120°F - 225°F  <br /> or <br /> cycling/ sweating conditions</>
];

const ProbabilityScoreGrid = ({ scores }) => {

    const { cellText, loading } = useProbabilityFlagBaseType();

    // Function to determine which row to highlight based on score value
    const getHighlightedRowIndex = (columnIndex, scoreValue) => {
        // Return the index where lastColData matches the score
        return lastColData.indexOf(scoreValue);
    }

    // Get highlighted row indices for each column
    const getHighlightedRows = () => {
        if (!scores) return {};

        return {
            0: getHighlightedRowIndex(0, scores.operatingTemperatureScore),
            1: getHighlightedRowIndex(1, scores.coatingStatusScore),
            2: getHighlightedRowIndex(2, scores.claddingorInsulationConditionScore),
            3: getHighlightedRowIndex(3, scores.insulationTypeScore),
            4: getHighlightedRowIndex(4, scores.heatTracingScore),
            5: getHighlightedRowIndex(5, scores.externalEnvScor)
        };
    }

    const highlightedRows = getHighlightedRows();

    // Inline styles for grid lines
    const gridStyles = {
        borderCollapse: "collapse",
        width: "100%",
        height: "100%",
    };

    const cellStyles = {
        border: "1px solid #ddd",
        padding: "8px",
        textAlign: "center"
    };

    const headerCellStyles = {
        ...cellStyles,
        backgroundColor: "#f2f2f2",
        fontWeight: "bold"
    };

    const highlightedCellStyles = {
        ...cellStyles,
        backgroundColor: "rgb(230, 245, 248)",
        fontWeight: "bold"
    };

    return (
        <div className="probability-score-grid">
            {loading ? (
                <div className="loading">Loading...</div>
            ) : (
                <table className="grid-table" style={gridStyles}>
                    <thead>
                        <tr>
                            {colTitles.map((title, index) => (
                                <th key={index} style={headerCellStyles}>{title}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: 4 }).map((_, rowIndex) => (
                            <tr key={rowIndex}>
                                {colTitles.map((_, colIndex) => {
                                    // Determine if this cell should be highlighted
                                    const isHighlighted = highlightedRows[colIndex] === rowIndex;
                                    const cellStyle = isHighlighted ? highlightedCellStyles : cellStyles;

                                    // For the last column (Score), use lastColData
                                    if (colIndex === 6) {
                                        return <td key={colIndex} style={cellStyle}>{lastColData[rowIndex]}</td>;
                                    }
                                    // For the first column (Operating Temperature), use operatingTempData
                                    else if (colIndex === 0) {
                                        return <td key={colIndex} style={cellStyle}>{operatingTempData[rowIndex]}</td>;
                                    }
                                    // For columns 1-5 (shifted due to new column), use data from cellText
                                    else if (colIndex < 6 && cellText[rowIndex]) {
                                        const keys = [
                                            'coating_Status',
                                            'claddingorInsulationCondition',
                                            'insulation_Type',
                                            'heat_Tracing',
                                            'external_Environment'
                                        ];
                                        return <td key={colIndex} style={cellStyle}>{cellText[rowIndex][keys[colIndex - 1]]}</td>;
                                    } else {
                                        return <td key={colIndex} style={cellStyle}>-</td>;
                                    }
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default ProbabilityScoreGrid;